export default __webpack_public_path__ + "static/media/nextdoor-icon.e0a4e8a1.png";